import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { GridDeprecated, Pagination } from '@adc/ui-adc'
import classnames from 'classnames/bind'
import CalendarHeader from '../calendarHeader'
import CalendarResults from '../calendarResults'
import ProcessingMessageWrapper from '../processingMessageWrapper'
import types from '../../constants/propTypes'
import STATICS from '../../statics'
import styles from './styles.scss'

/**
 * TODO: Make this into a standard `hooks.useOffsetPagination()` hooks we can share across apps.
 */
const DEFAULT_PAGE_SIZE = 25

const getStartIdx = (pageSize, pageNumber, total) =>
  Math.min(pageSize * (pageNumber - 1) + 1, total)

const getEndIdx = (startIdx, pageSize, total) =>
  Math.min(startIdx + pageSize - 1, total)

const getOffset = (activePage, pageSize = DEFAULT_PAGE_SIZE) =>
  (activePage - 1) * pageSize

const calculatePageNumber = (offset = 0, pageSize = DEFAULT_PAGE_SIZE) => {
  return pageSize !== 0 ? Math.floor(offset / pageSize) + 1 : 1
}

const calculateTotalPages = (total = 0, pageSize = DEFAULT_PAGE_SIZE) => {
  return pageSize !== 0 ? Math.ceil(total / pageSize) : 0
}

const { Row, Column } = GridDeprecated
const cx = classnames.bind(styles)

class CalendarResultsPanel extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      firstCall: true,
      stateFilter: '',
      productTypeFilter: '',
      buyingTypeFilter: '',
      bidEndDateFilter: '',
      hidePastEventsFilter: true,
      limit: DEFAULT_PAGE_SIZE,
    }
  }

  static propTypes = {
    events: PropTypes.array.isRequired,
    total: PropTypes.number.isRequired,
    count: PropTypes.number.isRequired,
    offset: PropTypes.number.isRequired,
    fetchEventsAction: PropTypes.func.isRequired,
    fetchEventsProgress: types.baseProgressType,
    params: types.params.isRequired,
  }

  static defaultProps = {
    fetchEventsProgress: null,
  }

  componentDidMount() {
    const { params } = this.props

    this.fetchEventsAction({
      stateFilter: { value: params.state },
      productTypeFilter: { value: params.product_type },
      hidePastEventsFilter: true,
    }).then(() => this.setState({ firstCall: false }))
  }

  fetchEventsAction = ({
    stateFilter,
    productTypeFilter,
    buyingTypeFilter,
    hidePastEventsFilter,
    bidEndDateFilter,
    offset,
  }) => {
    const { limit } = this.state
    return this.props
      .fetchEventsAction({
        product_type: productTypeFilter ? productTypeFilter.value : '',
        buying_type: buyingTypeFilter ? buyingTypeFilter.value : '',
        state: stateFilter ? stateFilter.value : '',
        bid_end_date: bidEndDateFilter || '',
        hide_past_events: hidePastEventsFilter,
        offset: offset || 0,
        limit,
      })
      .then(() => {
        this.setState({
          stateFilter,
          productTypeFilter,
          buyingTypeFilter,
          bidEndDateFilter,
          hidePastEventsFilter,
        })
      })
  }

  render() {
    const { fetchEventsProgress, events, total, count, offset, params } =
      this.props

    const { loading } = fetchEventsProgress
    const {
      firstCall,
      stateFilter,
      productTypeFilter,
      buyingTypeFilter,
      bidEndDateFilter,
      hidePastEventsFilter,
    } = this.state

    const currentPage = calculatePageNumber(offset)
    const totalPages = calculateTotalPages(total)
    const disablePrev = currentPage === 1
    const disableNext = currentPage === totalPages
    const startIdx = getStartIdx(DEFAULT_PAGE_SIZE, currentPage, total)
    const endIdx = getEndIdx(startIdx, DEFAULT_PAGE_SIZE, total)

    return (
      <main>
        <Row>
          <Column>
            <CalendarHeader
              fetchEventsAction={this.fetchEventsAction}
              params={params}
            />
            <div className={cx({ 'loading-calendar': loading })}>
              {loading && (
                <ProcessingMessageWrapper
                  message={STATICS.FETCHING_CALENDAR_EVENTS}
                  elmId='resi_calendar_table_processing_message'
                />
              )}
              {!firstCall && !loading && <CalendarResults events={events} />}
            </div>
          </Column>
        </Row>

        {!loading && total > 0 && (
          <Row>
            <Column medium={4}>
              <p data-elm-id={`calendar_page_table_size_${count}`}>
                Showing {startIdx} - {endIdx} of {total} results
              </p>
            </Column>

            <Column medium={8}>
              <div className={cx('calendar-page-pagination-container')}>
                <Pagination
                  className={cx('calendar-page-pagination')}
                  data-elm-id='calendar_page_pagination'
                  defaultActivePage={currentPage}
                  totalPages={totalPages}
                  firstItem={false}
                  lastItem={false}
                  pageItem={{ 'data-elm-id': 'number_pagination' }}
                  prevItem={{
                    content: '\u27E8',
                    disabled: disablePrev,
                    'data-elm-id': 'prev_pagination',
                  }}
                  nextItem={{
                    content: '\u27E9',
                    disabled: disableNext,
                    'data-elm-id': 'next_pagination',
                  }}
                  onPageChange={(e, { activePage }) => {
                    this.fetchEventsAction({
                      stateFilter,
                      productTypeFilter,
                      buyingTypeFilter,
                      bidEndDateFilter,
                      hidePastEventsFilter,
                      offset: getOffset(activePage),
                    })
                  }}
                />
              </div>
            </Column>
          </Row>
        )}
      </main>
    )
  }
}

export default CalendarResultsPanel
